import {showModal, closeModal} from "@/components/Modal/ModalHelpers"
import {success, forbidden, warning} from '@/components/Notification/notification';

export const menuMixin = {
    methods: {
        success,
        forbidden, 
        warning,
        closeModal,
        showModal,

        // TREE DRAG&DROP METHODS

        handleDragStart(node, ev) {
        },
        handleDragEnter(draggingNode, dropNode, ev) {
        },
        handleDragLeave(draggingNode, dropNode, ev) {
        },
        handleDragOver(draggingNode, dropNode, ev) {
        },
        handleDragEnd(draggingNode, dropNode, dropType, ev) {
          if (this.realtime) this.save(this.isEdit)
          if (draggingNode.level > 1) {
            this.warning('Menu can only have 2 levels')
        }
          
        },
        handleDrop(draggingNode, dropNode, dropType, ev) {
          console.log(draggingNode, dropNode, dropType, ev)
        },
        allowDrop(draggingNode, dropNode, type) {  
            if (dropNode.data.id === this.data[this.data.lenght-1]) {
                return type !== 'inner';
            } else {
                return true;
            }
        },
        allowDrag(draggingNode) {
            return draggingNode.data.label.indexOf(this.data[this.data.length-1].name.id) === -1;
        },
        handleCheckedChange(value) {
            this.test2 = value
            
        },
        handleChange(value) {            
        },
        isActiveTab(id) {
            return this.activeTab === id
        },
        displayDetails (data) {
            this.currentItem = data

            if (this.currentItem.content_id) {
                for (let section of this.sections) {
                    if (this.currentItem.content_id === section.id) {
                        this.currentItem.original = section.title.en
                    }
                }
            }            
        },
        updateLangData(updatedData) {
            this.test3[Object.keys(updatedData)[0]] = updatedData[Object.keys(updatedData)[0]]
        },
        saveNew () {
			
			this.$store.dispatch('saveMenu', menu)
			.then ((res) => {
				if (res.status === 'success') {
					if (!this.realtime)
						this.$router.push({name: 'MenuItems'})
					else {
						this.data = this.removeItemObject(res.menu.menu)
					}
				} else {
					if (res.err) {
						this.error = res.err
						this.data = this.removeItemObject(res.menu.menu)
					}
				}
			})
		},
        // SAVE MENU
        async save (isEdit) {
            console.log(isEdit)
            this.loading = true
            this.modalConfig.show = false;
            this.error = {}
            
            this.menuItem.menu = await this.addItemObject(this.data)
            
            let url
            this.isEdit ? url = 'updateMenu' : url = 'saveMenu'

            this.$store.dispatch(url, this.menuItem)
            .then ((res) => {
                if (res.status === 'success') {
                    if (!this.realtime)
                        this.$router.push({name: 'MenuItems'})
                    else 
                        setTimeout(() => { this.loading = false }, 1500)
                        this.data = this.removeItemObject(res.menu.menu)
                } else {
                    this.loading = false                    
                    if (res.err) {
                        this.error = res.err
                        this.data = this.removeItemObject(res.menu.menu)
                    }
                }
            })  
        },
        append(data) {
            const newChild = { id: this.id, label: '', content_id: null };
            this.id++
            if (!data.children) {
                this.$set(data, 'children', []);
            }
            this.addChild(this.data, data.$treeNodeId, newChild)
        },
        appendParent(data, data2) {

            let content = data2
             
            if (content.length) {
                for (let cont of content) {
                    data.push({
                        id: this.id,
                        label: cont.title.en,
                        content_id: cont.id,
                        name: cont.title,
                        children: []
                    })
                    this.id++
                }

            } else {
                data.push({
                    id: this.id,
                    label: content.title ? content.title.en : content.name.en,
                    content_id: content.id,
                    name: content.title ? content.title : content.name,
                    url: content.url ? content.url : '',
                    children: []
                    })
                this.id++
                this.test = []
                this.test3 = {}
            }
            
          },
          addChild (arr, id, data) {
          
            for (let child of arr) {
                
              if (child.$treeNodeId == id) {
          
                child.children.push(data)            
          
              } else if (child.children) {
          
                this.addChild (child.children, id, data)
          
              }
            }
          },
          checkChildren (data, node, item) {
            let test
              
            for (let child of data) {
            
                if (child.$treeNodeId === node.data.$treeNodeId) {
                    item.id ? child.content_id = item.id : delete child.content_id
                    item.url ? child.url = item.url : delete child.url
                    item.title ? child.name = item.title : test = 1
                    item.name ? child.name = item.name : test = 2
                } else if (child.children) {
            
                    this.checkChildren (child.children, node, item)
            
                }
            }
        },
        selectedContent(node, item) {

            this.checkChildren(this.data, node, item)
            this.showNode = false
          
            if (this.realtime) {
                this.save(this.isEdit)
            }
        },
        remove(node, data) {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex(d => d.id === data.id);
            children.splice(index, 1);
          
            if (this.realtime) {
                this.save(this.isEdit)
            }
        },

        remove(node, data) {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex(d => d.id === data.id);
            children.splice(index, 1);
          
            if (this.realtime) {
                this.save(this.isEdit)
            }
        },
        renderContent(h, { node, data, store }) {
            return (
              <span class="custom-tree-node">
                <span>{node.label}</span>
                <span>
                    <el-button size="mini" type="text" on-click={ () => this.append(data) }>Append</el-button>
                    <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>Delete</el-button>
                </span>
              </span>);
        },
        realtimeChecker() {
			this.realtime ? this.realtime = true : this.realtime = false
			this.modalConfig.show = false    
        },
        removeItemObject (array) {
            let menu = []
            for (let parent of array) {
                parent = parent.item
                delete parent.item
                parent.label = parent.name.en
                if (parent.children) {
                    let submenu = []
                    for (let firstChild of parent.children) {
                        firstChild = firstChild.item
                        delete firstChild.item
                        firstChild.label = firstChild.name.en
                        submenu.push(firstChild)
                    }
                    parent.children = submenu
                }
                menu.push(parent)                
            }
            return menu
        },
        
        addItemObject (array) {        
            let menu = []
            for (let parent of array) {
                let item = { item: {} }
                item.item = parent        
                parent = item
                if (parent.item['children']) {
                    let submenu = []
                    for (let firstChild of parent.item.children) {
                        let item = { item: {} }
                        item.item = firstChild
                        submenu.push(item)
                    }
                    parent.item.children = submenu
                }
                menu.push(parent)
            }            
            return menu
        }
    }
  }


// WEBPACK FOOTER //
// ./src/mixins/menuItems.js